import { dataTestIds } from '@velasca/constants'
import { SansText } from '../SansText/SansText'
import {
  Content,
  Description,
  LeftContainer,
  LineItemSizeButton,
  RightContainer,
} from './QuickAddSizeSelectorLine.styles'
import type { QuickAddSizeSelectorLineProps } from './QuickAddSizeSelectorLine.types'

export const QuickAddSizeSelectorLine = ({
  label,
  description,
  disabled,
  onClick,
  children,
  state,
}: QuickAddSizeSelectorLineProps): JSX.Element => {
  return (
    <LineItemSizeButton
      disabled={disabled}
      state={state}
      data-testid={disabled ? '' : dataTestIds.QUICK_ADD_TO_CART_LINE_ITEM}
      onClick={onClick}
    >
      <LeftContainer>
        <SansText fontWeight="500" color="inherit">
          {label}
        </SansText>
      </LeftContainer>
      <RightContainer>
        <Content>
          {description && (
            <Description>
              <SansText fontWeight="400" color="inherit">
                {description}
              </SansText>
            </Description>
          )}
          {children}
        </Content>
      </RightContainer>
    </LineItemSizeButton>
  )
}
